// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__17Rm-","colCheckbox":"styles_colCheckbox__24otv"};